import React, { useEffect } from 'react';
import Gradients from "../Gradients";
import Info from "../Info/Info";
import github from '../../images/github.png';

const IndividualProject = ({ project }) => {
  let shoes, shoeBackground, shoeHeight;

  // for responsive behaviour
  const changeHeight = () => {
    let x = window.matchMedia("(max-width:1000px)");

    !shoes ? (shoeHeight = 0) : (shoeHeight = shoes[0].offsetHeight);

    if (x.matches) {
      if (shoeHeight === 0) {
        try {
          setTimeout(changeHeight, 50);
        } catch (error) {
          alert("Something is Wrong!!");
        }
      }
      if (shoeBackground) {
        shoeBackground.style.height = `${shoeHeight * 0.9}px`;
      }
    } else if (!!shoeBackground) {
      // go back to default
      shoeBackground.style.height = "475px";
    }
  };

  useEffect(() => {
    shoes = document.querySelectorAll(".shoe");
    shoeBackground = document.querySelector(".shoeBackground");
    changeHeight();
  }, []);
  window.addEventListener("resize", changeHeight);

  return (
    <>
    <div className="container">
      <div className="card">
        <div className="shoeBackground">
          <Gradients />
          <img src={project.img} alt="Me" className="project-image" />
        </div>
        <Info heading={project.name} content={project.desc} />
      </div>
    </div>
    <div id="Container">
      <a href={project.github}>
        <img src={github} alt="github" style={{ width: '55px', marginBottom: '30px' }} />
      </a>
      <a href={project.link}>
        <button className="learn-more">
          <span className="circle" aria-hidden="true">
            <span className="icon arrow"></span>
          </span>
          <span className="button-text">Live Demo</span>
        </button>
      </a>
    </div>
    </>
  );
};

export default IndividualProject;
